import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { MFRECO_POSITION_DAY_BASE_PATH } from '../../../../../../../../../../features/mutual-funds/reconciliation/position-day/mfreco-position-day-routing';

export const Route = createFileRoute(
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/mutualfunds/reconciliation/position-day/_position-day',
)({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'mfreco-position-day-list',
        label: 'Mutual Funds',
        to: MFRECO_POSITION_DAY_BASE_PATH,
      }),
    }) satisfies AggregateBreadcrumb,
});
